import { backendFetch } from './client';

/**
 * YouTube-каналы (28.10.2026). Статистика публичная, по ключу API на бэкенде —
 * канал подключается ссылкой, входа в Google нет. Записи «Монтажа» (только
 * имя) получают ссылку, не меняя id `yt:<slug>`.
 */
export interface YouTubeChannelRecord {
  id: string;
  name: string;
  channelId?: string;
  handle?: string | null;
  link?: string;
  thumbnail?: string | null;
  partnerUserId?: string;
}

async function call<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await backendFetch(path, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...init.headers },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Ошибка ${res.status}`);
  return data as T;
}

export const youtubeApi = {
  channels: () => call<{ channels: YouTubeChannelRecord[] }>('/api/youtube/channels'),
  /** `id` — приклеить ссылку к уже заведённому каналу. */
  attach: (link: string, id?: string) =>
    call<{ channel: YouTubeChannelRecord; created: boolean }>('/api/youtube/channels', {
      method: 'POST',
      body: JSON.stringify({ link, id }),
    }),
  /** Партнёр — свой канал. */
  attachPartner: (link: string) =>
    call<{ channel: YouTubeChannelRecord; created: boolean }>('/api/youtube/partner/channels', {
      method: 'POST',
      body: JSON.stringify({ link }),
    }),
};
